import React from 'react'
import { Installation, InstallationsApiView } from 'src/Libs/installations'
import { BlankView, BlankViewImageSizes, BlankViewImageVariants } from 'src/Components/blank-view'
import { getPlannedInstallationsFetchProps } from 'src/Libs/installations/utils/installation-table-columns'

interface Props {
  onSelect: (installation?: Installation) => void
}

const PlannedInstallations: React.FC<Props> = ({ onSelect }) => {
  return (
    <InstallationsApiView
      keyValue={0}
      fetchProps={getPlannedInstallationsFetchProps}
      dataQaPrefix={'installations-planned'}
      onSelect={onSelect}
      blankView={
        <BlankView
          imageVariant={BlankViewImageVariants.Neutral}
          imageSize={BlankViewImageSizes.Small}
          title={'companyDashboard.blank-view.planned-installation.title'}
          explanation={'companyDashboard.blank-view.planned-installation.explanation'}
          fullHeight
        />
      }
      isPlannedView
    />
  )
}

export default PlannedInstallations
